
      <!--  CHECKBOX CONTROL  -->

      <div [formGroup]="form" class="control" [class.is-invalid]="isInvalid">

          <!--  HIDDEN INPUT  -->

          <input [id]="id" type="checkbox" [formControlName]="name" (change)="onCheckChange($event)"/>

          <!--  END HIDDEN INPUT  -->

          <!--  LABEL  -->

          <label [for]="id">

              <!--  CHECKBOX CONTAINER  -->

              <span class="checkbox-container" [ngClass]="{'acc-hl-bg acc-hl-bd' : isChecked()}" [class.neg-bd]="isInvalid"></span>

              <!--  END CHECKBOX CONTAINER  -->

              <!--  CHECKBOX TICK  -->

              <i class="far fa-check"></i>

              <!--  END CHECKBOX TICK  -->

              <!--  INDETERMINATE DASH  -->

              <span *ngIf="isIndeterminate()" class="indeterminate"></span>

              <!--  END INDETERMINATE DASH  -->

              <span class="text">

                  <!--  TEXT PARTS LOOP  -->

                  <ng-template ngFor let-textPart [ngForOf]="textParts">

                      <!--  CTA  -->

                      <a *ngIf="isCta(textPart)" class="pri-hl-col" (click)="onCtaClick($event, textPart)">{{ getCtaText(textPart) }}</a>

                      <!--  END CTA  -->

                      <!--  PLAIN TEXT  -->

                      <span *ngIf="!isCta(textPart)">{{ textPart }}</span>

                      <!--  END PLAIN TEXT  -->

                  </ng-template>

                  <!--  END TEXT PARTS LOOP  -->

              </span>

          </label>

          <!-- END CHECKBOX LABEL  -->

      </div>

      <!--  END CHECKBOX CONTROL  -->
    